import { anonymousPuiApi } from '@client/api/waterlily';
import { selectClient } from '@client/model';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

export function usePuiHistory() {
  const client = useSelector(selectClient);
  const clientId = client.clientId;

  const { data, refetch, isFetching, isError, isLoading } = useQuery<PUIHistoryItem[]>({
    queryKey: ['anonymousPuiHistory', clientId],
    queryFn: () => anonymousPuiApi.fetchHistory(clientId),
    enabled: !!clientId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });

  return { data, refetch, isFetching, isError, isLoading };
}
